<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div :class="'pb-4 text-center px-4 ' + containerClass">
          <SmartIcon
            type="big"
            :name="icon"
            :size="iconSize"
            :class="[typeColor, rotateLoad]"
            class="my-2"
          />
          <SmartTitle>
            {{ title }}
          </SmartTitle>
          <div
            class="modal-body mt-2 mb-3 font-opacity-md"
            :class="textColor">
            <slot />
          </div>
          <div class="modal-footer w-full" :class="[ thirdButton && fourthButton ?  'button-inline' : '' ]">
            <SmartButton
              v-if="buttonText"
              secondary
              class="is-secondary"
              :loading="loadingFirstButton"
              @click="onFirstClick">
              {{ buttonText }}
            </SmartButton>
            <SmartButton
              v-if="secondButton"
              :disabled="loadingFirstButton"
              :loading="loadingSecondButton"
              quaternary
              class="is-secondary ml-1"
              @click="onSecondClick">
              {{ secondButton }}
            </SmartButton>
            <SmartButton
              v-if="thirdButton"
              quinary
              class="is-secondary"
              @click="onFirstClick">
              {{ thirdButton }}
            </SmartButton>
            <SmartButton
              v-if="fourthButton"
              secondary
              class="is-secondary ml-1"
              @click="onFourthClick">
              {{ fourthButton }}
            </SmartButton>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// @flow
export default {
  name: 'SmartModal',
  props: {
    iconSize: {
      type: Number,
      default: 9
    },
    containerClass: {
      type: String,
      default: 'modal-container-smaller'
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: '',
      validator(value: string) {
        return ['success', 'warning', 'danger', 'default'].includes(value);
      }
    },
    buttonText: {
      type: String,
      default: ''
    },
    secondButton: {
      type: String,
      default: ''
    },
    thirdButton: {
      type: String,
      default: ''
    },
    fourthButton: {
      type: String,
      default: ''
    },
    loadingFirstButton: {
      type: Boolean,
      default: false
    },
    loadingSecondButton: {
      type: Boolean,
      default: false
    },
    routerRedirect: {
      type: String,
      default: ''
    },
    onButtonClick: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    typeColor() {
      switch (this.type) {
      case 'success':
        return 'text-ui-success';
      case 'warning':
        return 'text-ui-warning';
      case 'danger':
        return 'text-ui-danger';
      case 'default':
        return 'text-ui-gradient-gray';
      default:
        return '';
      }
    },
    textColor() {
      switch (this.color) {
      case 'success':
        return 'text-ui-success';
      case 'warning':
        return 'text-ui-warning';
      case 'danger':
        return 'text-ui-danger';
      case 'default':
        return 'text-ui-gradient-gray';
      default:
        return '';
      }
    },
    rotateLoad() {
      return this.icon === 'union' ? 'loadingRotate' : '';
    }
  },
  methods: {
    onFirstClick(event: InputEvent) {
      this.onButtonClick();
      this.$emit('close', event);
      if (this.routerRedirect) { this.$router.push({ name: this.routerRedirect }); }
    },
    onSecondClick(event: InputEvent) {
      this.$emit('return', event);
    },
    onFourthClick(event: InputEvent) {
      this.$emit('event', event);
    }
  }
};
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  left: 4px;
  top: 4px;
  background: #FFFFFF;
  margin: 0px auto;
  transition: all .3s ease;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24), 0px 0px 4px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
}
.modal-container-smaller {
  @extend .modal-container;
  max-width: 400px;
}
.modal-container-bigger {
  @extend .modal-container;
  max-width: 800px;
}

.modal-header h1{
  width: 256px;
  height: 30px;
  left: 70px;
  top: 108px;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 24px;
  text-align: center;
  letter-spacing: -0.04em;
  color: #000000;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.button-inline {
  display: inline-grid;
}

.loadingRotate{
  -webkit-animation:rotateUnion 4s linear infinite;
  -moz-animation:rotateUnion 4s linear infinite;
  animation:rotateUnion 4s linear infinite;
}

@keyframes rotateUnion {
  0% {
    transform: translate3d(0, 0, 0) rotate(0);
  }
  100% {
    transform: translate3d(0, 0, 0) rotate(360deg);
  }
}
</style>
